
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as guideU_cdE1QOKiXUqv_45CRGstM4eEiZOz3JBbQQgHtwq2K0AMeta } from "/app/pages/guide.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as gadgetNrJumdW0sgbeME83eAm8Q6kzNA1IPGqk5v42VDDNtYoMeta } from "/app/pages/gadget.vue?macro=true";
import { default as zencare_zNt5qQVJ_45HA0oMXhNI6SsgLdfBb7YkqdGnIY0OHgPcMeta } from "/app/pages/zencare.vue?macro=true";
import { default as about_45usWFQXpt2DA4_34Qah2UTFFyJ33ypdDo2QsAhRa5cVZQUMeta } from "/app/pages/about-us.vue?macro=true";
import { default as flexicarevGEiJHjfi6h7dJRy_45aKq_lXebjEloTTbaQVf7rGF6jgMeta } from "/app/pages/flexicare.vue?macro=true";
import { default as primecareOqVlV95DG3v8FRiEljtvocrmJ3peoQ3E4koNoodKVlYMeta } from "/app/pages/primecare.vue?macro=true";
import { default as resources7GrMzS8RxW_45RyNUWJYxpIylOwqmb_45xi9Zos7YDGuHFoMeta } from "/app/pages/resources.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as individualU7TASmgFLoShhnM41Fkr2o5EyBpTvNSGUZjD1xJqbCcMeta } from "/app/pages/individual.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_45fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as indexWuBZbRLZAPQJ5ogWbvxeY_45YdW2pKiFg_45DDKbURpVGKYMeta } from "/app/pages/icons/index.vue?macro=true";
import { default as third_45party6kKp3pYTV8gA1R1_45cKuO5yfB38Ar3Y4rD6V3J9bWio0Meta } from "/app/pages/third-party.vue?macro=true";
import { default as travel_45coverDPlo1xXdGPBn1h3dCsqq2_iH9dEaOf6Qkg1JrW9vTYYMeta } from "/app/pages/travel-cover.vue?macro=true";
import { default as cookie_45policyobIGMQYUw6rt9Qc9OcdKPEKq_Zy03HD556Uygv48nqwMeta } from "/app/pages/cookie-policy.vue?macro=true";
import { default as indexTNffsQm_xezsHZ_K_45nmCeluIvqlwezgq9wKIzLQVv3EMeta } from "/app/pages/campaign/index.vue?macro=true";
import { default as privacy_45policyzgG_45S68_451GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as indexYtVvqVqVlFabpRJCFxtdR6VyDA4E1K5dDz0qM0drmQkMeta } from "/app/pages/sendcare/index.vue?macro=true";
import { default as benefits_45editorWUcxMiTTMQ7liK8Ac3yTnuZnc_45mhvlA4sSP6j1loiMAMeta } from "/app/pages/benefits-editor.vue?macro=true";
import { default as waitlistInrxNpUppy03n2inT8puF0waK4_aZTdyXEbVJvNtbikMeta } from "/app/pages/sendcare/waitlist.vue?macro=true";
import { default as mini_45comprehensiveanhCE3Be2OW13bPrmVNXZmL2kfTBO9q1rCRBU_45VVUi0Meta } from "/app/pages/mini-comprehensive.vue?macro=true";
import { default as _91id_93Db6_Mgs4wx_1WEuUCdYl6_wnb3LgqX85egtFO7aL8gsMeta } from "/app/pages/product-guide/[id].vue?macro=true";
import { default as comprehensive_45coverErIcG_45pM0k0wOEW6_45JHfHRofapVlo3_45znkDLnP4b_JAMeta } from "/app/pages/comprehensive-cover.vue?macro=true";
import { default as indexfJb618UJgWBqACo1ZyMZIxE1nd8_Eu5rN5R2p3hDpCsMeta } from "/app/pages/product-guide/index.vue?macro=true";
import { default as terms_45and_45conditionsRU14D3TdeoevONy87DoGrbDHcLlYVbN3gK81tRUROX4Meta } from "/app/pages/terms-and-conditions.vue?macro=true";
import { default as _91product_93Az4o0aFcCXJ0M_45671XmwXyLEkTLiu4FYB135mHooNp4Meta } from "/app/pages/hospital-list/[product].vue?macro=true";
import { default as save_45with_45zencare_45x9TwXSfQouWX_QyDQYo0J21HwM978krfuaLqospMnMMeta } from "/app/pages/campaign/save-with-zencare.vue?macro=true";
import { default as _91product_93__91provider_93rs8BGMOorJMSFF_45jP8QVh31UChJXn_45RomQOZ4MoTdbQMeta } from "/app/pages/hospital-list/provider/[product]_[provider].vue?macro=true";
export default [
  {
    name: "guide",
    path: "/guide",
    component: () => import("/app/pages/guide.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "gadget",
    path: "/gadget",
    meta: gadgetNrJumdW0sgbeME83eAm8Q6kzNA1IPGqk5v42VDDNtYoMeta || {},
    component: () => import("/app/pages/gadget.vue")
  },
  {
    name: "zencare",
    path: "/zencare",
    meta: zencare_zNt5qQVJ_45HA0oMXhNI6SsgLdfBb7YkqdGnIY0OHgPcMeta || {},
    component: () => import("/app/pages/zencare.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/app/pages/about-us.vue")
  },
  {
    name: "flexicare",
    path: "/flexicare",
    meta: flexicarevGEiJHjfi6h7dJRy_45aKq_lXebjEloTTbaQVf7rGF6jgMeta || {},
    component: () => import("/app/pages/flexicare.vue")
  },
  {
    name: "primecare",
    path: "/primecare",
    meta: primecareOqVlV95DG3v8FRiEljtvocrmJ3peoQ3E4koNoodKVlYMeta || {},
    component: () => import("/app/pages/primecare.vue")
  },
  {
    name: "resources",
    path: "/resources",
    component: () => import("/app/pages/resources.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "individual",
    path: "/individual",
    component: () => import("/app/pages/individual.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "icons",
    path: "/icons",
    component: () => import("/app/pages/icons/index.vue")
  },
  {
    name: "third-party",
    path: "/third-party",
    meta: third_45party6kKp3pYTV8gA1R1_45cKuO5yfB38Ar3Y4rD6V3J9bWio0Meta || {},
    component: () => import("/app/pages/third-party.vue")
  },
  {
    name: "travel-cover",
    path: "/travel-cover",
    meta: travel_45coverDPlo1xXdGPBn1h3dCsqq2_iH9dEaOf6Qkg1JrW9vTYYMeta || {},
    component: () => import("/app/pages/travel-cover.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/app/pages/cookie-policy.vue")
  },
  {
    name: "campaign",
    path: "/campaign",
    meta: indexTNffsQm_xezsHZ_K_45nmCeluIvqlwezgq9wKIzLQVv3EMeta || {},
    component: () => import("/app/pages/campaign/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "sendcare",
    path: "/sendcare",
    meta: indexYtVvqVqVlFabpRJCFxtdR6VyDA4E1K5dDz0qM0drmQkMeta || {},
    component: () => import("/app/pages/sendcare/index.vue")
  },
  {
    name: "benefits-editor",
    path: "/benefits-editor",
    component: () => import("/app/pages/benefits-editor.vue")
  },
  {
    name: "sendcare-waitlist",
    path: "/sendcare/waitlist",
    meta: waitlistInrxNpUppy03n2inT8puF0waK4_aZTdyXEbVJvNtbikMeta || {},
    component: () => import("/app/pages/sendcare/waitlist.vue")
  },
  {
    name: "mini-comprehensive",
    path: "/mini-comprehensive",
    meta: mini_45comprehensiveanhCE3Be2OW13bPrmVNXZmL2kfTBO9q1rCRBU_45VVUi0Meta || {},
    component: () => import("/app/pages/mini-comprehensive.vue")
  },
  {
    name: "product-guide-id",
    path: "/product-guide/:id()",
    component: () => import("/app/pages/product-guide/[id].vue")
  },
  {
    name: "comprehensive-cover",
    path: "/comprehensive-cover",
    meta: comprehensive_45coverErIcG_45pM0k0wOEW6_45JHfHRofapVlo3_45znkDLnP4b_JAMeta || {},
    component: () => import("/app/pages/comprehensive-cover.vue")
  },
  {
    name: "product-guide",
    path: "/product-guide",
    component: () => import("/app/pages/product-guide/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/app/pages/terms-and-conditions.vue")
  },
  {
    name: "hospital-list-product",
    path: "/hospital-list/:product()",
    meta: _91product_93Az4o0aFcCXJ0M_45671XmwXyLEkTLiu4FYB135mHooNp4Meta || {},
    component: () => import("/app/pages/hospital-list/[product].vue")
  },
  {
    name: "campaign-save-with-zencare",
    path: "/campaign/save-with-zencare",
    meta: save_45with_45zencare_45x9TwXSfQouWX_QyDQYo0J21HwM978krfuaLqospMnMMeta || {},
    component: () => import("/app/pages/campaign/save-with-zencare.vue")
  },
  {
    name: "hospital-list-provider-product_provider",
    path: "/hospital-list/provider/:product()_:provider()",
    meta: _91product_93__91provider_93rs8BGMOorJMSFF_45jP8QVh31UChJXn_45RomQOZ4MoTdbQMeta || {},
    component: () => import("/app/pages/hospital-list/provider/[product]_[provider].vue")
  }
]